module.exports = __webpack_public_path__ + "img/pic4.3e322b96.png";